document.addEventListener('DOMContentLoaded', function () {

    const consentPopup = document.getElementById('consent-popup');
    const acceptButton = document.getElementById('accept-consent');
    const declineButton = document.getElementById('decline-consent');
    const consentKey = 'user_consent_preference';
    const gtm_id = 'GTM-W7HZ3RPK'; // Also set in top of body in index.html

    const consentDefaults = {
        ad_storage: 'denied',
        analytics_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied'
    };

    const consentGranted = {
        ad_storage: 'granted',
        analytics_storage: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted'
    };

    let gtmInitialized = false;

    window.dataLayer = window.dataLayer || [];
    function gtag() { dataLayer.push(arguments); }

    // Start with denied by default to respect consent mode until we know the user's choice.
    gtag('consent', 'default', consentDefaults);

    function setGTM(w, d, s, l, i) {
        if (gtmInitialized) {
            return;
        }

        w[l] = w[l] || [];
        w[l].push({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js'
        });

        const firstScript = d.getElementsByTagName(s)[0];
        const gtmScript = d.createElement(s);
        const dl = l !== 'dataLayer' ? '&l=' + l : '';

        gtmScript.async = true;
        gtmScript.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        firstScript.parentNode.insertBefore(gtmScript, firstScript);

        gtmInitialized = true;
    };

    function applyConsent(consentValue) {
        const granted = consentValue === 'granted';
        gtag('consent', 'update', granted ? consentGranted : consentDefaults);

        // Load GTM once; events queued in dataLayer will be read when the script is ready.
        setGTM(window, document, 'script', 'dataLayer', gtm_id);

        // Push a custom event so GTM can re-evaluate tags after the consent change.
        dataLayer.push({
            event: 'consent_update',
            consent_state: consentValue
        });
    }

    function setConsent(consentValue) {
        localStorage.setItem(consentKey, consentValue);
        consentPopup.style.display = 'none';
    }

    const currentConsent = localStorage.getItem(consentKey);

    if (!currentConsent) {
        // No choice yet: keep default denied, wait for user action.
        consentPopup.style.display = 'flex';
    } else if (currentConsent === 'granted') {
        applyConsent('granted');
    } else if (currentConsent === 'denied') {
        applyConsent('denied');
    }

    acceptButton.addEventListener('click', () => {
        setConsent('granted');
        applyConsent('granted');
    });

    declineButton.addEventListener('click', () => {
        setConsent('denied');
        applyConsent('denied');
    });
});
